import React from 'react';
import { PageHeader } from '@good/ui/templates';
import { useTranslation } from 'react-i18next';
import { ServiceBookingDocumentData } from 'utilities/react-trpc';
import { EmptyTablePlaceholder } from 'views/sil-service/components/empty-table-placeholder';
// import { SilTable } from 'views/sil-service/components/table';
import { LaptopDesk } from '@good/illustrations';

type IBookingFilesTabProps = {
  data: ServiceBookingDocumentData[];
};

export const BookingFilesTab = ({ data }: IBookingFilesTabProps) => {
  const { t } = useTranslation('', { keyPrefix: 'silService.filesTabs.bookingFiles' });

  const fileCount = data.length;

  return (
    <div data-testid='service-files-tab' className='w-full'>
      <PageHeader title={t('title')} subtitle={t('description')} size='h2' />
      {/* <SilTable data={bookingFiles} columns={customerFileColumns} isSelectable={false} /> */}
      {fileCount === 0 ? (
        <EmptyTablePlaceholder
          image={<LaptopDesk />}
          heading={t('empty.heading')}
          description={t('empty.description')}
        />
      ) : null}
    </div>
  );
};
